<ll-toolnavbar>
    <banner-toolnavbar [bannerId]="bannerId" [displayButtons]="'all new edit instancias'"></banner-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Banner #{{ bannerId || "" }}</ll-titulo>

<banner [bannerId]="bannerId"></banner>
